module.exports = {
  transpileDependencies: ['vuetify'],
  publicPath: '/',
  devServer: {
    host: 'localhost',
  },
};
